"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const SectionTitle_1 = __importDefault(require("./SectionTitle"));
const Loading_1 = require("./Loading");
const Section = ({ children, title, sectioncol, isLoading, tooltip }) => {
    if (!isLoading) {
        return (react_1.default.createElement(CustomSection, { sectioncol: sectioncol },
            title && react_1.default.createElement(SectionTitle_1.default, { title: title, tooltip: tooltip }),
            children));
    }
    else
        return (react_1.default.createElement(Loading_1.Loading, { style: {
                height: '400px',
                gridColumn: 'span 12',
            } }));
};
exports.default = Section;
const CustomSection = (0, styled_components_1.default)(material_1.Box) `
  display: grid;
  padding-top: ${(props) => props.theme?.spacing?.page?.xl};
  grid-column: span ${(props) => (props.sectioncol?.xl ? props.sectioncol?.xl : 12)};
  grid-template-columns: repeat(12, 1fr);
  gap: 20px;
  ${(props) => props.theme.media.lg} {
    grid-column: span ${(props) => (props.sectioncol?.lg ? props.sectioncol?.lg : 12)};
    padding-top: ${(props) => props.theme.spacing.page.lg};
  }
  ${(props) => props.theme.media.md} {
    grid-column: span ${(props) => (props.sectioncol?.lg ? props.sectioncol?.md : 12)};
    padding-top: ${(props) => props.theme.spacing.page.md};
  }
  ${(props) => props.theme.media.sm} {
    grid-column: span ${(props) => (props.sectioncol?.lg ? props.sectioncol?.sm : 12)};
    padding-top: ${(props) => props.theme.spacing.page.md};
  }
  ${(props) => props.theme.media.xs} {
    grid-column: span ${(props) => (props.sectioncol?.lg ? props.sectioncol?.xs : 12)};
    padding-top: ${(props) => props.theme.spacing.page.md};
  }
`;
